export const DAILY_TIP_DISMISSED_DATE_STORAGE_KEY =
  'dashboard_daily_tip_dismissed_date'

export const getLocalDateStamp = (date = new Date()) => {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')

  return `${year}-${month}-${day}`
}

export const isDailyTipDismissedToday = (
  dismissedDate: string | null | undefined,
  now = new Date(),
) => {
  return dismissedDate === getLocalDateStamp(now)
}
